import { useEffect, useRef, useState } from 'react';

import SharedAsset from '@zenbusiness/common-components/SharedAsset';
import Text from '@zenbusiness/common-components/Text';

import { Container, Animation } from './index.styles';

const Loading = () => {
  const [show, setShow] = useState(false);
  const timeoutId = useRef(null);

  useEffect(() => {
    timeoutId.current = setTimeout(() => {
      setShow(true);
    }, 1000);

    return () => {
      clearTimeout(timeoutId.current);
    };
  });

  if (!show) return null;

  return (
    <Container>
      <Animation>
        <Animation data-testid="animation" as={SharedAsset} src="https://res.cloudinary.com/zenbusiness/q_auto,fl_lossy/v1/shared-assets/animation/gif/just-zb-floating.gif" alt="loading" />
      </Animation>
      <Text size="sm" align="center">Loading...</Text>
    </Container>
  );
};

export default Loading;
